module.exports = __webpack_public_path__ + "static/media/topography-torn.601f7bc9.png";